<template>
    <rkm-layout-body title="Lista de unidade">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-unidade-create' })"
                color="primary"
                authorize="store-cadastro-unidade"
            >
                Cadastrar unidade
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/unidade/List'

export default {
    components: { List },
}
</script>